import { LocationData, SelectTrapDropdown } from '../types';

interface TrapModel {
  id: number;
  trap_type: string;
  sensor: string;
  type: string;
  controller: string;
  communication_controller: string;
  power_type: string;
  description: string;
}

interface FloorNumber {
  slug: string;
  title: string;
}

interface DefaultPan {
  on_plan: boolean;
  title: string;
  url_ending: string;
}

export interface BaitData {
  status: string;
  bait_filling: number;
  actual_eaten_bait: number;
}

export enum TrapActivityType {
  ACTIVITY = 'ACTIVITY',
  CONSUMPTION = 'CONSUMPTION',
}

export interface SRBMTrapData {
  id: number;
  activity_type: TrapActivityType;
  floor_number: FloorNumber;
  serial_number: string | null;
  sequence_number: number;
  bait_filling: string;
  bait_data: BaitData;
  qr_code: string;
  hub: string | null;
  date_of_installation: string;
  battery_percentage: number;
  slug: string;
  default_plan: DefaultPan | null;
  last_connect: string;
  last_activity: string;
  trap_type: string;
  connection_status: string;
  model: TrapModel;
  actual_eaten_bait_ordering: number;
  pest_visits: number;
  location: LocationData;
}

interface PestCompany {
  name: string;
  slug: string;
}

interface ObjectData {
  name: string;
  slug: string;
}

export interface SRBMDetailData {
  id: number;
  slug: string;
  work_time: number | null;
  eaten_bait_from_last_add: string;
  bait_filling: string;
  recomended_bait_filling: number;
  total_eaten_bait: number;
  serial_number: string;
  model: string;
  sequence_number: number;
  date_of_installation: string;
  battery_percentage: number;
  hub: string;
  pest_company: PestCompany;
  object: ObjectData;
  default_plan: DefaultPan | null;
  select_trap_dropdow_data: SelectTrapDropdown[] | null;
  last_maintenance: string | null;
  start_bait_filling: number;
}

export interface CombinedSRBMChartData {
  crm_date_time: string;
  date_time: string;
  bait_filling: number;
  bait_replacement: boolean;
  bait_add_btn: boolean;
  added_bait: number;
  is_added: boolean;
  eaten_bait: number;
}

export interface SRBMMonitoringHistoryData {
  id: number;
  msg_token: string;
  date_time: string;
  crm_date_time: string;
  bait_filling: number;
  battery_percentage: number;
  rssi: number;
  snr: number;
  activity_type: TrapActivityType;
}
